import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { en, th } from 'vuetify/es5/locale';
import '../styles/vuetify.scss'; 
Vue.use(Vuetify);

export default new Vuetify({
   defaultAssets: {
    font: {
      family: 'Noto Sans Thai', 
      googleFont: [
        {
          family: 'Noto Sans Thai',
          styles: 'wght@300;400;500;700', 
        },
      ],
    },
  },
  lang: {
    locales: { en, th },
    current: 'th',
  },
  theme: {
    themes: {
      light: {
        lightpink: '#FFECEF',
        headerBlack: '#292D32',
      },
    },
  },
});